import React from 'react';
import Title from 'antd/es/typography/Title';
import {Col, Row} from 'antd';
import {useLayoutState} from '../Context/LayoutProvider/LayoutProvider';
import {PopoverWithOptions} from './Layouts/PopoverWithOptions';

interface ViewProps {
    title: string;
    titleElement?: React.ReactNode;
    buttons?: React.ReactNode[];
    forceOpenHamburgerButton?: boolean;
}
export const PageTitle : React.FunctionComponent<ViewProps> = (props) => {
    const { title, titleElement, buttons, forceOpenHamburgerButton } = props;

    const { isSmallScreen } = useLayoutState();

    const TITLE = React.useMemo(()=>{
        return <Title level={2}>{title}{ titleElement !== undefined && titleElement }</Title>;
    }, [title, titleElement]);

    const  BUTTONS_ELEMENT = React.useMemo( ()=>{
        if ( buttons !== undefined && buttons.length === 0 ){
            return null;
        }

        if( isSmallScreen ){
            return (
                <div style={{ display: 'flex', justifyContent: 'flex-end'}}>
                    <PopoverWithOptions title="Opciones" options={ buttons !== undefined ? buttons : [] } forceOpen={forceOpenHamburgerButton}/>
                </div>
            );
        }

        return (
            <div style={{ display: 'flex', justifyContent: 'flex-end',  gap: '1rem'}}>
                { buttons }
            </div>
        );
    }, [buttons, forceOpenHamburgerButton, isSmallScreen] );


    if ( buttons !== undefined && buttons.length === 0 ){
        return  TITLE;
    }

    return (
        <Row align="middle">
            <Col xs={22} md={16}>
                { TITLE }
            </Col>
            <Col xs={2} md={8}>
                { BUTTONS_ELEMENT }
            </Col>
        </Row>
    );
};
